import { render, staticRenderFns } from "./AssetManagement.vue?vue&type=template&id=c1a0889a&scoped=true&"
import script from "./AssetManagement.vue?vue&type=script&lang=js&"
export * from "./AssetManagement.vue?vue&type=script&lang=js&"
import style0 from "./AssetManagement.vue?vue&type=style&index=0&id=c1a0889a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a0889a",
  null
  
)

export default component.exports